(() => {
  if (customElements.get('mvp-layout')) return;
  class MvpLayout extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.shell = this.closest('.shopify-section') || this.parentElement;
      this.measure = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          const viewport = document.documentElement.clientWidth;
          const edge = this.shell.getBoundingClientRect().left;
          this.style.setProperty('--mvp-viewport-width', `${viewport}px`);
          this.style.setProperty('--mvp-edge-offset', `${edge}px`);
        });
      };
      this.resize = new ResizeObserver(this.measure);
      this.resize.observe(document.documentElement);
      this.resize.observe(this.shell);
      window.addEventListener('resize', this.measure, { signal: this.abort.signal });
      this.measure();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('mvp-layout', MvpLayout);
})();
